var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAdr = function SvgAdr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 48,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFD666",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.948 49.735V15.608h-4.286v34.127zM64.826 49.735V2.91H60.54v46.825zM49.704 49.735V12.963h-4.286v36.772zM34.582 49.735V6.085h-4.286v43.65zM19.46 49.735V2.91h-4.286v46.825zM4.097 49.735V0H.049v49.735z"
  }))));
};
export default SvgAdr;